import { computed } from "mobx";
import { useEffect, useMemo } from "react";
import { useLeadStore, useRecordedSaleStore } from "..";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import ILead from "../interfaces/ILead";
import Shape from "../interfaces/Shape";
import useCircleWithRadius from "./useCircleWithRadius";
import useLeadsInsideShape from "./useLeadsInsideShape";
import useLeadsWithFocusArea from "./useLeadsWithFocusArea";

export function useRecordedSalesInRadius(coordinates: IGeoCoordinate, radius: number): ILead[] {
    const leads = useLeadsWithSaleDateInLastTwoYears();
    const circle = useCircleWithRadius(coordinates, radius)!;
    const recordedSales = useMemo(() => leads.filter(l => circle!.isPointInside(l.centerPoint)), [leads, circle]);

    return recordedSales;
}

export function useRecordedSalesInsideShape(shape: Shape | Shape[] | null): ILead[] {
    const leads = useLeadsWithSaleDateInLastTwoYears();
    const recordedSales = useLeadsInsideShape(leads, shape);

    return recordedSales;
}

export function useRecordedSalesInStore(recordedSales: ILead[]): void {
    const recordedSaleStore = useRecordedSaleStore();

    useEffect(() => {
        recordedSaleStore.setRecordedSales(recordedSales);

        return () => recordedSaleStore.setRecordedSales([]);
    }, [recordedSales]);
}

const useLeadsWithSaleDateInLastTwoYears = (): ILead[] => {
    const leadStore = useLeadStore();

    return useLeadsWithFocusArea(useMemo(() => computed(() => {
        const minSaleDate = new Date(new Date().setMonth(new Date().getMonth() - 24));
        return leadStore.leads.filter(l => l.saleDate && l.saleDate >= minSaleDate);
    }), []).get());
}